// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React from "react";
import { Button } from "@amzn/awsui-components-react/polaris";
import { useTranslation } from "react-i18next";
import log from "../../../../logging";

const AuthButton = (): JSX.Element => {
  const { t } = useTranslation();

  const onClick = () => {
    log.logMessage("SignIn button clicked.");
    window.location.href = `${window.location.origin}/authenticate`;
  };

  return (
    <Button className="Button-form" onClick={onClick}>
      <span id="span-text">{t("login.button.label")}</span>
    </Button>
  );
};

export default AuthButton;
